import React, { useState ,useEffect} from "react";
import { Link } from "react-router-dom";
import InnerHeader from "../InnerHeader/InnerHeader";
import Input from "../Input/Input";
import ThemeBtn from "../ThemeBtn/ThemeBtn";
import { register } from "../../api/LoginService";
import FetchService from "../../api/FetchService";
import LoadingOverlay from "react-loading-overlay";
import ImageUploading from "react-images-uploading";
import { ImageUploader } from "../../utility-components/ImageUploader/ImageUploader";
import { getFilters } from "../../commons/activity-filters/Helpers";
import deleteImg from "../../img/remove.png"
import {getAllActivityCategories} from "../../commons/activity-filters/Helpers"

import Form from "react-bootstrap/Form";
import "./AddActivity.scss";
import AttachActivity from "../../Dashboard/AttachActivity/AttachActivity";
import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import TransportSelector from "../TransportSelector/TransportSelector";



const priceModelArray = [
  { label: "Per person", value: "person" },
    { label: "Per aktivitet", value: "activity" },
    { label: "Per time", value: "time" },

];

let activityInit = {
  name: "",
  city: "",
  price: 0,
  originalPrice: 0,
  validPeriodEnd: "",
  validPeriodStart: "",
  liveDate: "",
  terms: "",
    description: "",
    childoriginalPrice: 0,
    childprice: 0,
  //imagePath: "",
  minPerson: 0,
  maxPerson: 0,
  discountPercent: 0,

  addDate: new Date().toISOString().slice(0, 10),

  instagram: null,
  facebook: null,
  youtube: null,
  priceModel: "person",
};

function AddActivity({ setIsLoading }) {
  const [images, setImages] = useState([]);

  const [name, setName] = useState("");
    const [type, setType] = useState("fysisk");
    const [subtype, setsubtype] = useState([]);
    const [resetFlag, setResetFlag] = useState(false);
    const [activity, setActivity] = useState(activityInit);


  const [city, setCity] = useState(["oslo"]);

    const [childoriginalPrice, setchildOriginalPrice] = useState(0);
    const [childprice, setChildPrice] = useState(0);


  const [price, setPrice] = useState(0);
  const [originalPrice, setOriginalPrice] = useState(0);

  const [priceModel, setPriceModel] = useState("person");

  const [validPeriodStart, setValidPeriodStart] = useState("");
  const [validPeriodEnd, setValidPeriodEnd] = useState("");
  const [liveDate, setLiveDate] = useState("");

  const [description, setDescription] = useState("");
  const [terms, setTerms] = useState("");
  const [instagram, setInstagram] = useState("");
  const [facebook, setFacebook] = useState("");
  const [youtube, setYoutube] = useState("");

  const [minPerson, setMinPerson] = useState(0);
  const [maxPerson, setMaxPerson] = useState(0);

  const [category, setCategory] = useState("vennegjeng");
  const [categories, addCategory] = useState(["vennegjeng"])

  const [response, setResponse] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [partnerId, setPartnerID] = useState(0);
  const [partnerName, setPartnerName] = useState("");
  const [hasCancellation, setHasCancellation] = useState(false);
  const [deadlineDays, setDeadlineDays] = useState(null);


// Add fonts to whitelist and register them
const Font = Quill.import("formats/font");
Font.whitelist = [
  "arial",
  "comic-sans",
  "courier-new",
  "georgia",
  "helvetica",
  "lucida",
  "meirio",
  "cursive",
  "gothic"
];
Quill.register(Font, true);

  const modules = {
    toolbar: [
      [{ 'font': ['Inter','Roboto','monospace'] }],
      [{ 'align': [false, 'center', 'right'] }],
      [{ 'list': 'bullet' }],
      ['bold', 'italic', 'underline'],
      ['link'],
      [{ 'size': ['small', false, 'large', 'huge'] }]
    ],
  };

  const formats = [
    'font',
    'align',
    'list',
    'bold',
    'italic',
    'underline',
    'strike',
    'link',
    'size'
    ];


    const [subCategory, setsubCategory] = useState([]);

    const filters = getFilters("add");
    const [childPriceOption, setChildPriceOption] = useState(activity.childStripePaymentID ? 'allowed' : 'notAllowed');

    const handleChildPriceChange = (event) => {
        setChildPriceOption(event.target.value);
    };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    if (images === null || images.length == 0) {
        alert("Error: Images cannot be empty");
        setIsLoading(false);


    } else {
        activity.name = name;
        let cityE = "";
        city.forEach((categoryE, index) => {
            if (index !== 0) {
                cityE += ", " + categoryE;
            } else {
                cityE += categoryE;
            }
        })

     activity.city = cityE;
        
      activity.price = +price;

      activity.originalPrice = +originalPrice;

        if (childPriceOption == "notAllowed") {
            activity.childprice = 0;
            activity.childoriginalPrice = 0;
            activity.childStripePaymentID = activity.childstripePaymentID;
            activity.childStripeProductID = activity.childStripeProductID;
        }
        else {
            activity.childprice = +childprice;
            activity.childoriginalPrice = +childoriginalPrice;
            activity.childStripePaymentID = activity.childstripePaymentID;
            activity.childStripeProductID = activity.childStripeProductID;

        }



      activity.validPeriodEnd = validPeriodEnd;
      activity.validPeriodStart = validPeriodStart;
      activity.liveDate = liveDate;

      activity.description = description;
      activity.terms = terms;

      activity.minPerson = +minPerson;
      activity.maxPerson = +maxPerson;
      let newCat = "";
      categories.forEach((categoryE,index)=>{
        if(index!==0){
          newCat += ", " + categoryE;
        }else{
          newCat += categoryE;
        }
      })


    let subtypeID = "";
    subtype.forEach((categoryE, index) => {
        if (index !== 0) {
            subtypeID += "," + categoryE;
        } else {
            subtypeID += categoryE;
        }
    })


      activity.category = newCat;
      activity.activityType = type;
      activity.subCategoryID = subtypeID;
      activity.discountPercent = ((originalPrice - price) / originalPrice) * 100 || 0;
      activity.ownerID = partnerId;

      //  setIsLoading(true);
      activity.images = images.map((x) => x.data_url);

      activity.instagram = instagram ?? null;
      activity.facebook = facebook ?? null;
      activity.youtube = youtube ?? null;

      activity.priceModel = priceModel;

      activity.cancellationDeadlineDays = hasCancellation ? deadlineDays : null;

      //console.table(activity);


      FetchService.AddActivity(activity).then((response) => {
          if (response) {
              setSession(null);

          setResponse("Success");
          clearForm();
          window.scrollTo(0, 0);
          setIsLoading(false);
        } else {
          setResponse("Failed");
          window.scrollTo(0, 0);
          setIsLoading(false);
        }
      });
    }
  };

    function setSession(obj) {
        sessionStorage.setItem("SearchResultAdmin", JSON.stringify(obj));
    }

  function clearForm() {
    setName("");
    setPrice(0);
    setOriginalPrice(0);
    setMinPerson(0);
    setMaxPerson(0);
    setValidPeriodEnd("");
    setValidPeriodStart("");
    setTerms("");
    setDescription("");
    setLiveDate("");
    setPartnerID(0);
    setPartnerName(0);
    setImages([]);
    setFacebook("");
    setInstagram("");
    setYoutube("");
    setsubtype("");
    setActivity([]);
    setHasCancellation(false);
    setDeadlineDays(false);

  }

  const handleTerms = (props) =>{
    setTerms(props)
  }

  const handleDesc = (props) =>{
    setDescription(props)
  }



  function getCategoryName(categoryVal){
    const categoriesLabels = getAllActivityCategories();
    const nameCategory = categoriesLabels.filter(categoryLabel => categoryLabel.value === categoryVal);
    return nameCategory[0].label;
  }

    const deleteCategory = (event) => {
        
        const delCategory = event.currentTarget.dataset.category; // Correct way to get data attribute
        if (categories.length <= 1) {
            return; // Avoids removing the last category
        }
        return addCategory(categories.filter(categoryF => categoryF !== delCategory))
    };

    async function GetAllSubCategories() {
        try {
            const response = await FetchService.GetAllSubCategories();
            return response.data;  // Assuming response.data is an array of subCategory
        } catch (error) {
            console.error("Error fetching subCategory:", error);
            return [];
        }
    }
    useEffect(() => {
        const fetchsubCategory = async () => {
            try {
                const data = await GetAllSubCategories();
                const formattedData = data.map(sub => ({
                    value: sub.name,
                    id: sub.id
                }));
                
                setsubCategory(formattedData);
            } catch (error) {
                console.error("Error fetching subCategory:", error);
            }
        };

        fetchsubCategory(); // Call the function

    }, []); // Empty dependency array ensures it runs only once


  return (
    <>
      <div className="Register_page">
        {/* Todo: might need to change this in future for better design
        <InnerHeader HeaderHeading="Activity" PageText="Add Activity" />
     */}

        <section className="">
          <div className="container">
            <div className="row_custom data-grid">
              <div className="">
                <div className="">
                   <h2 class="form_heading inner_header_main">Legg til aktivitiet</h2>
                  {response === "Failed" && (
                    <div className="error_message">
                      {
                        "Feil: Systemet kunne ikke lagre aktiviteten. Vær så snill, prøv på nytt."
                      }
                    </div>
                  )}
                  {response === "Success" && (
                    <div className="success_message">
                      {"Aktiviteten er lagt til."}
                    </div>
                  )}

                  <form onSubmit={handleSubmit} className="form_main">
                    <div className="row row_custom_inr row_custom_inr1">
                      <div className="col-lg-6 col_input_otr">
                        <div className="col_input_inr">
                          <div className="Input_otr">
                            <Input
                              InputClass="Theme_input_white form_input"
                              Inputype="text"
                              InputName="name"
                              label="Aktivitetsnavn"
                              value={name}
                              onChange={(event) => setName(event.target.value)}
                            />
                          </div>
                          <div className="Input_otr">
                            {"Kategori B2C"}
                            <Form.Select
                              className="Theme_input_white form_input"
                              aria-label="Default select example"
                              value={category}
                              onChange={(event) => {
                                if(!categories.includes(event.target.value)) {
                                  addCategory(categories.concat(event.target.value));
                                  setCategory(event.target.value);
                                }
                              }}
                            >
                              {filters.categories.map((option) => (
                                <option value={option.value}>
                                      {categories.includes(option.value) ? "✔" : (<p>&nbsp;&nbsp;&nbsp;</p>)} {option.label}
                                </option>
                              ))}
                             </Form.Select>
                             <div className="dflex">
                            {categories.map(categoryOne=>(
                                <div className="my-1 btn btn-primary-form">
                                    <i
                                        onClick={deleteCategory}
                                        data-category={categoryOne} // ✅ Add dataset attribute
                                        className="ri-delete-bin-5-line">
                                    </i>{getCategoryName(categoryOne)}
                              </div>
                            ))}
                            </div>
                                                  </div>

                                                  <div className="Input_otr">
                                                      {"Kategori B2B"}

                                                      <Form.Select
                                                          key={resetFlag}  // Force re-render on reset
                                                          className="Theme_input_white form_input"
                                                          aria-label="Default select example"
                                                          value={subtype?.length > 0 ? subtype[subtype?.length - 1] : ""}
                                                          onChange={(event) => {
                                                              const selectedValue = event.target.value === "" ? null : parseInt(event.target.value);

                                                              if (selectedValue === null) {
                                                                  setsubtype([]);
                                                                  setResetFlag((prev) => !prev); // Change key to trigger re-render
                                                              } else if (!subtype.includes(selectedValue)) {
                                                                  setsubtype([...subtype, selectedValue]);
                                                              }
                                                          }}
                                                      >
                                                          <option value="">ⓧ Ingen</option>
                                                          {subCategory.map((option) => (
                                                              <option key={option.id} value={option.id}>
                                                                  {subtype.includes(option.id) ? "✔" : " "} {option.value}
                                                              </option>
                                                          ))}
                                                      </Form.Select>


                                                      {subtype && subtype.length>0 && <div className="dflex">
                                                          {subtype.map(categoryOne => (
                                                              <div className="my-1 btn btn-primary-form">
                                                                  <i onClick={(event) => {
                                                                      setsubtype(subtype.filter(cityf => cityf !== categoryOne));
                                                                  }} key={categoryOne} class="ri-delete-bin-5-line"></i>{subCategory.filter(x => x.id == categoryOne)[0].value}
                                                              </div>
                                                          ))}
                                                      </div>}


                                                  </div>
                          <div className="Input_otr">
                            {"By"}
                            <Form.Select
                              className="Theme_input_white form_input"
                              aria-label="Default select example"
                               value={city[city.length-1]}
                                                          onChange={(event) => {
                                                              if (!city.includes(event.target.value)) {
                                                                  setCity([...city, event.target.value]); 
                                                              }
                                  

                              }}
                            >
                              {filters.cities.map((option) => (
                                <option value={option.value}>
                                      {city.includes(option.value) ? "✔" : (<p>&nbsp;&nbsp;&nbsp;</p>)}  {option.label}
                                </option>
                              ))}
                               </Form.Select>

                                <div className="dflex">
                                  {city.map(categoryOne => (
                                        <div className="my-1 btn btn-primary-form">
                                          <i onClick={(event) => {
                                              setCity(city.filter(cityf => cityf !== categoryOne));
                                          }} key={categoryOne} class="ri-delete-bin-5-line"></i>{categoryOne}
                                        </div>
                                    ))}
                                </div>
         
                          </div>
                          <div className="Input_otr">
                            {"Aktivitetstype"}
                            <Form.Select
                              className="Theme_input_white form_input"
                              aria-label="Default select example"
                              value={type}
                              onChange={(event) => {
                                setType(event.target.value);
                              }}
                            >
                              {filters.types.map((option) => (
                                <option value={option.value}>
                                  {option.label}
                                </option>
                              ))}
                            </Form.Select>
                                                  </div>

                                        


                                                

                        </div>
                      </div>
                      <div className="col-lg-6 col_img_otr">
                        <div className="col_img_inr">
                          <div className="image-uploader">
                            <ImageUploader setImagesCallBack={setImages} />
                          </div>
                        </div>
                      </div>
                    </div>

      

                <div class="row row_custom_inr row_custom_inr1">
                                          <div class="col-lg-6 col_input_otr">

                                              <div class="mb-2 mt-3">
                                                  <h6>Alternativ for barnas pris:</h6>
                                              </div>






                                              <div className="row section-form">

                                                  <div className="row">

                                                      <label>
                                                          <input
                                                              type="radio"
                                                              name="childPrice"
                                                              value="notAllowed"
                                                              checked={childPriceOption === 'notAllowed'}
                                                              onChange={handleChildPriceChange}
                                                          />
                                                          Barnas pris ikke tillatt
                                                      </label>
                                                      <label>
                                                          <input
                                                              type="radio"
                                                              name="childPrice"
                                                              value="allowed"
                                                              checked={childPriceOption === 'allowed'}
                                                              onChange={handleChildPriceChange}
                                                          />
                                                          Barnas pris tillatt
                                                      </label>
                                                  </div>


                                                  <div className="new-line"></div><h6>Antall voksen:</h6>

                                                  <div className="Input_otr col ">
                                                      <Input
                                                          InputClass="Theme_input_white form_input"
                                                          Inputype="number"
                                                          InputName="number"
                                                          label="Pris"
                                                          value={price}
                                                          onChange={(event) =>
                                                              setPrice(event.target.value)
                                                          }
                                                      />
                                                  </div>
                                                  <div className="Input_otr col ">
                                                      <Input
                                                          InputClass="Theme_input_white form_input"
                                                          Inputype="number"
                                                          InputName="number"
                                                          label="Orginalpris"
                                                          value={originalPrice}
                                                          onChange={(event) =>
                                                              setOriginalPrice(event.target.value)
                                                          }
                                                      />

                                                  </div>

                                                  {childPriceOption === 'allowed' && (
                                                      <>
                                                          <h6>Antall barn:</h6>
                                                          <div className="Input_otr col">
                                                              <Input
                                                                  InputClass="Theme_input_white form_input"
                                                                  Inputype="number"
                                                                  InputName="number"
                                                                  label="Pris"
                                                                  value={childprice}
                                                                  onChange={(event) => setChildPrice(event.target.value)}
                                                              />
                                                          </div>
                                                          <div className="Input_otr col">
                                                              <Input
                                                                  InputClass="Theme_input_white form_input"
                                                                  Inputype="number"
                                                                  InputName="number"
                                                                  label="Orginalpris"
                                                                  value={childoriginalPrice}
                                                                  onChange={(event) =>
                                                                      setchildOriginalPrice(event.target.value)
                                                                  }
                                                              />
                                                          </div>
                                                      </>
                                                  )}
                                              </div>
                    <div className="row">
                            <div className="Input_otr ">
                                <label class="label_input heading-xs">Pristype</label>
                                <Form.Select
                                    className="Theme_input_white form_input"
                                    aria-label="Default select example"
                                    value={priceModel}
                                    onChange={(event) => {
                                        setPriceModel(event.target.value);
                                    }}
                                >
                                    {priceModelArray.map((option) => (
                                        <option value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </Form.Select>
                            </div>
                        </div>
                    <div className="row">
                      <div className="Input_otr col">
                        <Input
                          InputClass="Theme_input_white form_input"
                          Inputype="number"
                          InputName="number"
                          label="Minimumspersoner"
                          value={minPerson}
                          onChange={(event) => setMinPerson(event.target.value)}
                        />
                      </div>
                      <div className="Input_otr col">
                        <Input
                          InputClass="Theme_input_white form_input"
                          Inputype="number"
                          InputName="number"
                          label="Maksimumspersoner"
                          value={maxPerson}
                          onChange={(event) => setMaxPerson(event.target.value)}
                        />
                      </div>
                  </div>
                <div className="row  section-form bg-lightgray">
                    <div class="mb-2 mt-1">
                        <h6>Spesifikke Avbestillingsvilkår?{" "}</h6>
                    </div>
                    <label>                        
                        <input
                            type="radio"
                            checked={hasCancellation}
                            onChange={() => {setHasCancellation(true);  setDeadlineDays(1); }}
                        />JA
                        <input
                            className="ml-4"
                            type="radio"
                            checked={!hasCancellation}
                            onChange={() => {setHasCancellation(false); setDeadlineDays(null);}}
                        />NEI
                    </label>
                        {hasCancellation && (
                            <div className="input-group mb-2 mt-3">
                                <button
                                    type="button"
                                    className="btn bg-orange"
                                    onClick={() =>
                                        setDeadlineDays((prev) =>
                                            Math.max(1, parseInt(prev || "1", 10) - 1)
                                        )
                                    }
                                >
                                    -
                                </button>

                                <input
                                    type="text"
                                    inputMode="numeric"
                                    className="form-control bg-transparent text-center"
                                    value={deadlineDays}
                                    onChange={(e) => {
                                        let val = e.target.value;

                                        // Allow empty while typing
                                        if (val === "") {
                                            setDeadlineDays("");
                                            return;
                                        }

                                        // Remove leading zeros
                                        if (val.length > 1) {
                                            val = val.replace(/^0+/, "");
                                        }

                                        // Only digits allowed
                                        if (!/^\d+$/.test(val)) return;

                                        // Always keep >= 1
                                        setDeadlineDays(parseInt(val, 10));
                                    }}
                                    onBlur={() => {
                                        // If left empty on blur → reset to 1
                                        if (deadlineDays === "" || parseInt(deadlineDays, 10) < 1) {
                                            setDeadlineDays(1);
                                        }
                                    }}
                                />

                                <button
                                    type="button"
                                    className="btn bg-orange"
                                    onClick={() =>
                                        setDeadlineDays((prev) =>
                                            prev === "" ? 1 : parseInt(prev, 10) + 1
                                        )
                                    }
                                >
                                    +
                                </button>
                            </div>
                        )}
                </div>

                </div>
                    <div class="col-lg-6 col_img_otr">
                          <div className="row" style={{ minHeight: 592} }>
                            <TransportSelector
                                                      onSelectionChange={({ isTransportPartner, isTransportFree, transportPartnerPrice }) => {
                                                          activity.isTransportPartner = isTransportPartner || false;
                                                          activity.isTransportFree = isTransportFree || false;
                                                          activity.transportPartnerPrice = transportPartnerPrice || 0;

                                                      }}
                                                      activity={activity}
                            />
                        </div>
                    </div>
                    </div>
                    <div className="row">
                      <div className="Input_otr col">
                        <Input
                          InputClass="Theme_input_white form_input"
                          Inputype="date"
                          InputName="number"
                          label="Gyldig fra"
                          value={validPeriodStart}
                          onChange={(event) =>
                            setValidPeriodStart(event.target.value)
                          }
                        />
                      </div>
                      <div className="Input_otr col">
                        <Input
                          InputClass="Theme_input_white form_input"
                          Inputype="date"
                          InputName="number"
                          label="Gyldig Til"
                          value={validPeriodEnd}
                          onChange={(event) =>
                            setValidPeriodEnd(event.target.value)
                          }
                        />
                      </div>
                      <div className="Input_otr col">
                        <Input
                          InputClass="Theme_input_white form_input"
                          Inputype="date"
                          InputName="number"
                          label="Live fra"
                          value={liveDate}
                          onChange={(event) => setLiveDate(event.target.value)}
                        />
                      </div>
                    </div>

                    <div className="Input_otr">
                      <Input
                        optional={true}
                        InputClass="Theme_input_white form_input"
                        Inputype="text"
                        InputName="facebook"
                        label="Facebook (Valgfri)"
                        value={facebook}
                        onChange={(event) => setFacebook(event.target.value)}
                      />
                    </div>

                    <div className="Input_otr">
                      <Input
                        optional={true}
                        InputClass="Theme_input_white form_input"
                        Inputype="text"
                        InputName="youtube"
                        label="Instagram (Valgfri)"
                        value={instagram}
                        onChange={(event) => setInstagram(event.target.value)}
                      />
                    </div>
                    <div className="Input_otr">
                      <Input
                        optional={true}
                        InputClass="Theme_input_white form_input"
                        Inputype="text"
                        InputName="youtube"
                        label="Youtube (Valgfri)"
                        value={youtube}
                        onChange={(event) => setYoutube(event.target.value)}
                      />
                    </div>
                    <div className="Input_otr">
                      <label className="label_input heading-xs">
                        {" "}
                        Beskrivelse
                      </label>

                      {/* <textarea
                        className="Theme_input_white form_input description"
                        name="description"

                        value={description}
                        onChange={(event) => setDescription(event.target.value)}
                      /> */}

                        <ReactQuill
                          className="Theme_input_white form_input description"
                          modules={modules}
                          formats={formats}
                          onChange={handleDesc}
                          name="description"
                          value={description}
                        />
                    </div>
                    <div className="Input_otr">
                      <label className="label_input heading-xs"> Vilkår</label>

                      {/* <textarea
                        className="Theme_input_white form_input description"
                        type="text"
                        name="terms"
                        value={terms}
                        onChange={(event) => setTerms(event.target.value)}
                      /> */}

                        <ReactQuill
                          className="Theme_input_white form_input description"
                          modules={modules}
                          formats={formats}
                          onChange={handleTerms}
                          name="terms"
                          value={terms}
                        />
                    </div>

                    <div>
                      {/* Add activity button if the partner is not attached. */}
                      {partnerId !== 0 && (
                        <>
                          <div className="Input_otr">
                            <p>
                              <b>Partner Id: </b> {partnerId}
                            </p>
                            <br />
                            <p>
                              <b>Partnernavn: </b> {partnerName}
                            </p>
                          </div>
                          <div className="Input_otr action_otr">
                            <button
                              type="submit"
                              className="Theme_btn_primary form_btn"
                            >
                              Legg til aktivitet
                            </button>
                          </div>
                        </>
                      )}
                      {partnerId === 0 && (
                        <button
                          type="button"
                          className="Theme_btn_primary form_btn"
                          onClick={() => {
                            setShowPopup(true);
                          }}
                        >
                          Knytt til partner
                        </button>
                      )}
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      {showPopup && (
        <div className="backdrop">
          <div className="backdrop-container">
            <AttachActivity
              setShowPopup={setShowPopup}
              setPartnerID={setPartnerID}
              setPartnerName={setPartnerName}
            />
          </div>
        </div>
      )}
    </>
  );
}

export default AddActivity;
